import { SetStateAction, useEffect, useState } from "react";
import { IBaseFilterBrokerRank } from "./BrokerRankIndex";
import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import SelectAllCheckBox from "../SelectAllCheckBox";
import { returnKeysToMapGeneric } from "../analyticsHelperFunctions";

export const orderMapDV01Filters: Record<string, number> = {
  "0 - 5K": 0,
  "5K - 10K": 1,
  "10K - 25K": 2,
  "25K - 50K": 3,
  "50K - 100K": 4,
  "100K - 500K": 5,
  "Above 500K": 6,
};

// export function returnKeysToMap(data: IBaseAnalyticsCombined[]) {
//   if (!Array.isArray(data) || data.length == 0) {
//     return { DV01BucketsKeys: [], currencyKeys: [] };
//   }

//   const structureTypesObj: Record<string, number> = {};

//   for (const item of data) {
//     structureTypesObj[item.DV01Buckets] =
//       (structureTypesObj[item.DV01Buckets] || 0) + Number(item.notional);
//   }

//   const DV01BucketsKeys = [];
//   for (const [key] of Object.entries(structureTypesObj)) {
//     DV01BucketsKeys.push(key);
//   }
//   DV01BucketsKeys.sort((a, b) => {
//     const orderA = orderMapDV01Filters[a] ?? Number.MAX_SAFE_INTEGER;
//     const orderB = orderMapDV01Filters[b] ?? Number.MAX_SAFE_INTEGER;
//     return orderA - orderB;
//   });
//   const currencyTypeObjects: Record<string, number> = {};

//   for (const item of data) {
//     currencyTypeObjects[item.currency] =
//       (currencyTypeObjects[item.currency] || 0) + Number(item.notional);
//   }

//   const currencyKeys = [];
//   for (const [key] of Object.entries(currencyTypeObjects)) {
//     currencyKeys.push(key);
//   }

//   return { DV01BucketsKeys, currencyKeys };
// }

const CurrencyAndDV01Filters = ({
  data,
  dataFilters,
  setDataFilters,
}: {
  data: IBaseAnalyticsCombined[];
  dataFilters: IBaseFilterBrokerRank;
  setDataFilters: React.Dispatch<SetStateAction<IBaseFilterBrokerRank>>;
}) => {
  const keys = ["DV01Buckets", "currency"] as (keyof IBaseAnalyticsCombined)[];

  const [keysToMap, setKeysToMap] = useState(
    returnKeysToMapGeneric(data, keys),
  );

  useEffect(() => {
    setKeysToMap(returnKeysToMapGeneric(data, keys));
  }, [data]);

  useEffect(() => {
    if (dataFilters && keysToMap) {
      setDataFilters({
        ...dataFilters,
        selectedCurrencies: keysToMap.currencyKeys,
        DV01BucketsKeys: keysToMap.DV01BucketsKeys,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckboxChange = (filterValue: string) => {
    const currentState = dataFilters.selectedCurrencies;

    let newData = [];
    if (currentState.includes(filterValue)) {
      // Remove if already selected
      newData = currentState.filter((c: string) => c !== filterValue);
    } else {
      // Add if not selected
      newData = [...currentState, filterValue];
    }
    setDataFilters({ ...dataFilters, selectedCurrencies: newData });
  };

  const handleCheckboxChangeDV01 = (bucket: string) => {
    const currentState = dataFilters.DV01BucketsKeys;

    let newData = [];
    if (currentState.includes(bucket)) {
      // Remove if already selected
      newData = currentState.filter((c: string) => c !== bucket);
    } else {
      // Add if not selected
      newData = [...currentState, bucket];
    }

    setDataFilters({ ...dataFilters, DV01BucketsKeys: newData });
  };

  return (
    <>
      {keysToMap ? (
        <div className="flex h-full w-full justify-between overflow-hidden">
          <div className="flex h-full w-full flex-col pl-2">
            <div>Currency:</div>
            <div className="flex h-fit flex-col overflow-auto pl-2 pt-2">
              <SelectAllCheckBox
                dataFilters={dataFilters}
                setDataFilters={setDataFilters}
                dataFilterField={"selectedCurrencies"}
                keysToMap={keysToMap}
                keysToMapField={"currencyKeys"}
              />
              {keysToMap.currencyKeys.map((currency, index) => (
                <div className=" text-xs" key={index}>
                  <input
                    type="checkbox"
                    className=" accent-blue-500"
                    checked={
                      dataFilters && dataFilters.selectedCurrencies
                        ? dataFilters.selectedCurrencies.includes(currency)
                        : undefined
                    }
                    onChange={() => handleCheckboxChange(currency)}
                  />
                  <span className="pl-1">{currency}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex h-full w-full flex-col pl-2">
            <div>DV01 Bucket:</div>

            <div className="flex h-full flex-col overflow-auto pl-2 pt-2">
              <SelectAllCheckBox
                dataFilters={dataFilters}
                setDataFilters={setDataFilters}
                dataFilterField={"DV01BucketsKeys"}
                keysToMap={keysToMap}
                keysToMapField={"DV01BucketsKeys"}
              />
              {keysToMap.DV01BucketsKeys.map((bucket, index) => (
                <div className=" text-xs" key={index}>
                  <input
                    type="checkbox"
                    className=" accent-blue-500"
                    checked={
                      dataFilters && dataFilters.DV01BucketsKeys
                        ? dataFilters.DV01BucketsKeys.includes(bucket)
                        : undefined
                    }
                    onChange={() => handleCheckboxChangeDV01(bucket)}
                  />
                  <span className="pl-1">{bucket}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default CurrencyAndDV01Filters;
